module.exports = __webpack_public_path__ + "./fonts/HKGrotesk-Regular.ttf";